import React, { useEffect, useMemo, useState } from 'react';
import FeaturesContext, { Features } from 'context/FeaturesContext';
import { FeaturesProviderProps } from './FeaturesProvider.props';

/* eslint-disable max-len */
/*
- Enable typing in console
localStorage.setItem('features', JSON.stringify({documents:true}));dispatchEvent(new Event('storage'));
- Disable typing in console
localStorage.removeItem('features');dispatchEvent(new Event('storage'));
*/

export const FeaturesProvider = ({ children }: FeaturesProviderProps) => {
  const [featuresEnabled, setFeaturesEnabled] = useState<string | null>(localStorage.getItem('features') ?? null);

  const handleStorageEvent = (): void => {
    // maybe display a notification or something
    setFeaturesEnabled(localStorage.getItem('features'));
  };

  useEffect(() => {
    window.addEventListener('storage', handleStorageEvent);

    return () => {
      window.removeEventListener('storage', handleStorageEvent);
      setFeaturesEnabled(null);
    };
  }, []);

  const parsedFeatures = useMemo(
    () => (featuresEnabled ? (JSON.parse(featuresEnabled) as Features) : {}),
    [featuresEnabled]
  );

  const contextValue = useMemo(() => ({ features: parsedFeatures }), [parsedFeatures]);

  return <FeaturesContext.Provider value={contextValue}>{children}</FeaturesContext.Provider>;
};
